export interface UnlockReceiptData {
  buyerPosition: number;
  paidAmountCents: number;
  paidCurrency: string;
  presentmentAmount: number | null;
  presentmentCurrency: string | null;
  nextPriceCents: number | null;
  nextPriceCurrency: string | null;
}

export function isUnlockReceiptData(value: unknown): value is UnlockReceiptData {
  if (!value || typeof value !== "object") return false;
  const receipt = value as Partial<UnlockReceiptData>;
  const validNextPrice =
    (receipt.nextPriceCents === null && receipt.nextPriceCurrency === null) ||
    (Number.isSafeInteger(receipt.nextPriceCents) &&
      Number(receipt.nextPriceCents) > 0 &&
      typeof receipt.nextPriceCurrency === "string" &&
      /^[a-z]{3}$/.test(receipt.nextPriceCurrency));
  const validPresentment =
    (receipt.presentmentAmount === null && receipt.presentmentCurrency === null) ||
    (Number.isSafeInteger(receipt.presentmentAmount) &&
      Number(receipt.presentmentAmount) > 0 &&
      typeof receipt.presentmentCurrency === "string" &&
      /^[a-z]{3}$/.test(receipt.presentmentCurrency));
  return (
    Number.isSafeInteger(receipt.buyerPosition) &&
    Number(receipt.buyerPosition) > 0 &&
    Number.isSafeInteger(receipt.paidAmountCents) &&
    Number(receipt.paidAmountCents) > 0 &&
    typeof receipt.paidCurrency === "string" &&
    /^[a-z]{3}$/.test(receipt.paidCurrency) &&
    validPresentment &&
    validNextPrice
  );
}
